module.exports = __webpack_public_path__ + "static/img/币币交易_图3.3b184cf9.png";